import { render, staticRenderFns } from "./ActionOwngoal.vue?vue&type=template&id=154f8b65"
import script from "./ActionOwngoal.vue?vue&type=script&lang=js"
export * from "./ActionOwngoal.vue?vue&type=script&lang=js"
import style0 from "./ActionOwngoal.vue?vue&type=style&index=0&id=154f8b65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports